import type { ReactNode } from 'react'
import styles from './ApiRoulette.module.css'

export function ApiRouletteSectionHeading({
  step,
  title,
  children,
  actions,
}: {
  step: string
  title: string
  children: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className={styles.sectionHeading}>
      <div className={styles.headingContent}>
        <span className={styles.stepNumber} aria-hidden="true">
          {step}
        </span>
        <div>
          <span className={styles.stepLabel}>Etapa {step}</span>
          <h3>{title}</h3>
          <p>{children}</p>
        </div>
      </div>
      {actions && <div className={styles.headingActions}>{actions}</div>}
    </div>
  )
}
